<div class="sidebar-slide-header">
  <span class="title">
    <img *ngIf="icon" [src]="icon" [alt]="displayTitle" class="header-icon" />
    <ng-content select="[title-content]"></ng-content>
    {{ displayTitle }}
    <ng-content select="[title-extra]"></ng-content>
  </span>
  <div class="center-item">
    <ng-content select="[center-item]"></ng-content>
  </div>
  <div class="header-actions">
    <ng-content></ng-content>
    <span *ngIf="showClose" class="close-icon" (click)="close()">
      <img
        class="close-sidebar-icon"
        [src]="closeIcon"
        [alt]="closeTooltip"
        [pTooltip]="closeTooltip"
        tooltipPosition="bottom"
      />
    </span>
  </div>
</div>
